module.exports = __webpack_public_path__ + "static/c47a31aaa04dd3e76cc698a1b6bc97d5b1e96d298045c0ddce07ee282a5ab02d-9513b12751f92318b8b0d633d5d8ccc5.png";